export const BASE = {
  name: 'register',
  path: '/register',
} as const;
